import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language files
import fa from './locales/fa.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGUAGES = ['en', 'fa', 'ar'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const resources = {
  en: { translation: en },
  fa: { translation: fa },
  ar: { translation: ar }
};

function applyDocumentLangAndDir(lng: string) {
  if (typeof document === 'undefined') return;
  const lang = lng === 'fa' ? 'fa' : lng === 'ar' ? 'ar' : 'en';
  document.documentElement.setAttribute('lang', lang);
  const dir = lang === 'en' ? 'ltr' : 'rtl';
  document.documentElement.setAttribute('dir', dir);
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fa',
    fallbackLng: 'fa',
    supportedLngs: SUPPORTED_LANGUAGES,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage']
    }
  });

i18n.on('languageChanged', (lng: string) => {
  const base = (lng || '').split('-')[0];
  applyDocumentLangAndDir(SUPPORTED_LANGUAGES.includes(base as SupportedLanguage) ? base : 'fa');
});
i18n.on('initialized', () => {
  const lng = (i18n.language || i18n.resolvedLanguage || 'fa').split('-')[0];
  applyDocumentLangAndDir(SUPPORTED_LANGUAGES.includes(lng as SupportedLanguage) ? lng : 'fa');
});
const initial = (i18n.language || i18n.resolvedLanguage || 'fa').split('-')[0];
applyDocumentLangAndDir(SUPPORTED_LANGUAGES.includes(initial as SupportedLanguage) ? initial : 'fa');

export default i18n;
